<template>
<div class="d-flex justify-space-between">
    <div class="d-flex flex-column align-start">
        <div class="bar--text text--darken-2 display-1 font-weight-light">
            {{title}}
        </div>

        <v-btn text small class="info--text ml-n2" @click="$router.push(btn_to)">
            <div class="d-flex align-center">
                <v-icon size="12px" color="info">fa-arrow-left</v-icon>
                <div class="ml-2 caption font-weight-bold">{{btn_txt}}</div>
            </div>
        </v-btn>
    </div>

    <!-- <div class="font-weight-light grey--text text--darken-1s caption" v-if="$vuetify.breakpoint.lgAndUp">
        <i>The Rokken App</i>
    </div> -->
</div>
</template>

<script>
export default {
    props: ['title', 'btn_to', 'btn_txt']
}
</script>